export enum LogLevelValue {
  Debug = 1,
  Info = 2,
  Warning = 3,
  Error = 4,
  Critical = 5,
}

export interface ILogEntry {
  ApplicationName: string;
  EventId: number;
  Level: LogLevelValue;
  Message: string;
  Tag: string | null;
  Time: string;
  EventTask: number;
  Keywords: number;
  Opcode: number;
  Payload: string | null;
  ProcessId: number;
  ThreadId: number;
  Created: string;
  BrowserFingerprint: string;
}

export interface ICreateFrontendLogResult {
  success: boolean;
  id?: number;
  errorNumber?: number;
  message?: string;
}

export type ICreateEftLogResult = ICreateFrontendLogResult;

export interface ICreateLogEntryInput {
  eventId?: number;
  level?: LogLevelValue;
  message: string;
  tag?: string | null;
  payload?: unknown;
  applicationName?: string;
  time?: string | Date;
  eventTask?: number;
  keywords?: number;
  opcode?: number;
  processId?: number;
  threadId?: number;
  browserFingerprint?: string;
}

export interface IEftLogEntry {
  Action: number;
  Created: string;
  DeviceID: number;
  DocumentNumber: string | null;
  EventTime: string;
  JournalNumber: string | null;
  Message: string | null;
  Note: string | null;
  ProcessId: number;
  TerminalID: string | null;
  Text: string | null;
  ThreadId: number;
}

export interface ICreateEftLogInput {
  action: number;
  created?: string | Date;
  paymentUID?: string | null;
  deviceId?: number;
  documentNumber?: string | null;
  eventTime?: string | Date;
  journalNumber?: string | null;
  message?: string | null;
  note?: string | null;
  browserFingerprint?: string | null;
  bnr?: string | number | null;
  variableNumber?: string | number | null;
  voucherNumber?: string | number | null;
  processId?: number;
  terminalId?: string | null;
  text?: string | null;
  threadId?: number;
  methodName?: string | null;
  details?: Record<string, unknown>;
}